import { configureStore } from "@reduxjs/toolkit";
import buyerReducer from "./slices/buyerSlice";
import loaderReducer from './slices/commonLoaderSlice'

export const store = configureStore({
  reducer: {
    buyer: buyerReducer,
    loader: loaderReducer
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    }),
});

export default store;
